import { render } from "./FacturadorColombiaView.vue?vue&type=template&id=50bba328&scoped=true"
import script from "./FacturadorColombiaView.vue?vue&type=script&lang=js"
export * from "./FacturadorColombiaView.vue?vue&type=script&lang=js"

import "./FacturadorColombiaView.vue?vue&type=style&index=0&id=50bba328&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bba328"]])

export default __exports__